import RelationshipsView from "../RelationshipsView.vue";
import RelationshipsList from "../Pages/RelationshipsList.vue";
import RelationshipsEditor from "../Pages/RelationshipsEditor.vue";

const routes = [
  {
    path: 'relaciones-de-codigos',
    component: RelationshipsView,
    children: [
      {
        path: '',
        name: 'celulares-relationships-list',
        roles: ['relaciones_codigo'],
        component: RelationshipsList
      },
      {
        path: 'crear',
        name: 'celulares-relationships-create',
        roles: ['relaciones_codigo_agregar'],
        component: RelationshipsEditor
      },
      {
        path: ':id/editar',
        name: 'celulares-relationships-edit',
        roles: ['relaciones_codigo_editar'],
        component: RelationshipsEditor,
      }
    ]
  },
]

export default routes
